import React, {PropsWithChildren, useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {scrollLeftAction, scrollRightAction} from '../../store/actions/presentation.actions';
import {JS_INTERACTABLE_ELEMENT} from '../../constants';

export const JS_HORIZONTAL_SCROLLABLE_ELEMENT = 'js-horizontal-scrollable-element';

function SlideSwiper({children}: PropsWithChildren<unknown>): JSX.Element {
    const containerRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const [startX, setStartX] = useState<number | null>(null);
    const [endX, setEndX] = useState<number | null>(null);
    const [startedInsideInteractive, setStartedInsideInteractive] = useState(false);

    useEffect(() => {
        const container = containerRef.current;

        const handleTouchStart = (e: TouchEvent): void => {
            const isInteractive = !!(e.target as Element).closest(`.${JS_INTERACTABLE_ELEMENT}`);
            setStartedInsideInteractive(isInteractive);
            setStartX(e.touches[0].clientX);
        };

        const handleTouchMove = (e: TouchEvent): void => {
            setEndX(e.touches[0].clientX);
        };

        const handleTouchEnd = (e: TouchEvent): void => {
            const isInsideHorizontalScrollableElement = !!(e.target as Element).closest(`.${JS_HORIZONTAL_SCROLLABLE_ELEMENT}`);

            if (startedInsideInteractive || isInsideHorizontalScrollableElement) {
                setStartedInsideInteractive(false);
                return;
            }

            if (startX && endX) {
                const deltaX = endX - startX;

                if (deltaX > 100) {
                    dispatch(scrollLeftAction());
                } else if (deltaX < -100) {
                    dispatch(scrollRightAction());
                }
            }
            setStartX(null);
            setEndX(null);
            setStartedInsideInteractive(false);
        };

        if (container) {
            container.addEventListener('touchstart', handleTouchStart);
            container.addEventListener('touchmove', handleTouchMove);
            container.addEventListener('touchend', handleTouchEnd);

            return () => {
                container.removeEventListener('touchstart', handleTouchStart);
                container.removeEventListener('touchmove', handleTouchMove);
                container.removeEventListener('touchend', handleTouchEnd);
            };
        }
        return () => null;
    }, [startX, endX, dispatch, startedInsideInteractive]);

    return <div ref={containerRef}>{children}</div>;
}

export default SlideSwiper;
